import type { SxProps, Theme } from "@mui/material/styles";

export const root: SxProps<Theme> = (theme) => ({
  width: "auto",
  minWidth: 206,
  color: theme.palette.text.secondary,
  borderColor: theme.palette.divider,
  boxShadow: "none",
  fontWeight: 700,

  "&:hover": {
    borderColor: theme.palette.text.secondary,
    backgroundColor: theme.palette.action.hover,
    boxShadow: "none",
  },
});
